import { darken, lighten } from '../../../../helpers';
/**
 *  Constants
 */
export const darkenValue = 10;
export const lightenValue = 10;
/**
 *  Colors
 */
const brandTertiary = '#F1D40D';
const brandTertiaryLight = '#FFE740';
const brandTertiaryDark = '#F1BF0D';
const brandTertiaryUltraLight = '#FFF3C6';
const brandPrimary = '#FF652B';
const brandPrimaryDark = '#FE3A0C';
const brandPrimaryUltraLight = '#FFEFE9';
const brandPrimaryLight = '#FF8A5E';
const brandSecondary = '#585992';
const brandSecondaryDark = '#454672';
const brandSecondaryUltraLight = '#EEEEF3';
const brandSecondaryLight = '#68699D';
const brandHiring = '#24BB72';
const brandHiringDark = '#13B165';
const brandHiringUltraLight = '#A7E4C7';
const brandHiringLight = '#33CC82';
const brandHiringBlack = '#3B3F51';
const brandAlternativeAlert = '#FAB306';
const brandAlternativeError = '#EC0000';
const avisoGold = '#F1D40D';
const avisoTecno = '#3B76CE';
const avisoInfinitPrimary = '#8E3DF5';
const avisoZonajobs = '#FE633F';
const avisoBumeran = '#E90066';
const greyScale100 = '#000018';
const greyScale84 = '#29293D';
const greyScale72 = '#474759';
const greyScale60 = '#666474';
const greyScale48 = '#858590';
const greyScale36 = '#A3A3AC';
const greyScale24 = '#C2C2C8';
const greyScale16 = '#D6D6DA';
const greyScale8 = '#EBEBED';
const greyScale4 = '#F5F5F6';
const greyScale0 = '#FFFFFF';
const success = '#07862B';
const info = '#259DD5';
const warning = '#FAB006';
const danger = '#EC0000';
const link = `#586992`;
const extra = '#088ACA';
const extraDark = '#2E9DCD';
const extraLight = '#47B0E2';
const extraUltraLight = '#F0F8FF';
/**
 * Background color for `<body>`.
 */
const bodyBg = '#EEEEEE';
const toggleBackground = '#9899DA';
const colors = {
    primary: {
        ultraLighten: brandPrimaryUltraLight,
        normal: brandPrimary,
        lighten: brandPrimaryLight,
        darken: brandPrimaryDark,
    },
    secondary: {
        ultraLighten: brandSecondaryUltraLight,
        normal: brandSecondary,
        lighten: brandSecondaryLight,
        darken: brandSecondaryDark,
    },
    extra: {
        ultraLighten: extraUltraLight,
        normal: extra,
        lighten: extraLight,
        darken: extraDark,
    },
    tertiary: {
        ultraLighten: brandTertiaryUltraLight,
        lighten: brandTertiaryLight,
        normal: brandTertiary,
        darken: brandTertiaryDark,
    },
    hiring: {
        ultraLighten: brandHiringUltraLight,
        normal: brandHiring,
        darken: brandHiringDark,
        lighten: brandHiringLight,
        black: brandHiringBlack,
    },
    grey100: greyScale100,
    grey84: greyScale84,
    grey72: greyScale72,
    grey60: greyScale60,
    grey48: greyScale48,
    grey36: greyScale36,
    grey24: greyScale24,
    grey16: greyScale16,
    grey8: greyScale8,
    grey4: greyScale4,
    grey0: greyScale0,
    alternativeAlert: brandAlternativeAlert,
    alternativeError: brandAlternativeError,
    info: {
        normal: info,
        darken: darken(info, darkenValue),
        lighten: lighten(info, lightenValue),
    },
    success: {
        lighten: lighten(success, lightenValue),
        normal: success,
        darken: darken(success, darkenValue),
    },
    warning: {
        normal: warning,
        darken: darken(warning, darkenValue),
        lighten: lighten(warning, lightenValue),
    },
    danger: {
        normal: danger,
        darken: darken(danger, darkenValue),
        lighten: lighten(danger, lightenValue),
    },
    link: {
        lighten: lighten(link, lightenValue),
        normal: link,
        darken: darken(link, darkenValue),
    },
    aviso: {
        border: {
            freemium: brandPrimary,
            talento: brandPrimary,
            tecnologia: avisoTecno,
            destacado: avisoGold,
            simple: brandPrimary,
            home: brandPrimary,
            zonajobs: avisoZonajobs,
            infinit: avisoInfinitPrimary,
            bumeran: avisoBumeran,
        },
        infinit: {
            brandPrimary: avisoInfinitPrimary,
        },
        destaque: {
            tecnologia: avisoTecno,
            destacado: avisoGold,
            home: brandPrimary,
            zonajobs: avisoZonajobs,
            bumeran: avisoBumeran,
        },
    },
    'body-bg': bodyBg,
    toggleBackground: toggleBackground,
};
export default colors;
